module.exports = __webpack_public_path__ + "assets/img/2.7241b19a.png";